import { ReactNode, useState } from "react";
import { ArtifactSlotContext } from "./artifact-context";

export function ArtifactProvider(props: { children?: ReactNode }) {
  const content = useState<HTMLElement | null>(null);
  const title = useState<HTMLElement | null>(null);

  // Detect if device is mobile (match Tailwind's md breakpoint: 768px)
  const isMobile = typeof window !== 'undefined' && window.matchMedia("(max-width: 767px)").matches;

  // Initialize open to "default" so artifact is open by default on desktop
  const open = useState<string | null>("default");
  const mounted = useState<string | null>("default"); // Initialize to "default" so demo artifact renders immediately
  const context = useState<Record<string, unknown>>({});
  // Always true on desktop - artifact panel is always visible and cannot be closed
  // On mobile, artifact is hidden entirely (not just closed)
  const showArtifact = useState<boolean>(!isMobile);

  return (
    <ArtifactSlotContext.Provider
      value={{ open, mounted, title, content, context, showArtifact }}
    >
      {props.children}
    </ArtifactSlotContext.Provider>
  );
}
